import React, { useEffect, useState } from "react";
import "./personality.css";

// Posters
import arrival from "../../movies/inteligente/arrival.jpg";
import enemy from "../../movies/inteligente/enemy.jpg";
import inception from "../../movies/inteligente/inception.jpg";
import memento from "../../movies/inteligente/memento.jpg";
import mrnobody from "../../movies/inteligente/mrnobody.jpg";
import notesonascandal from "../../movies/inteligente/notesonascandal.jpg";
import thegirlwiththedragontattoo from "../../movies/inteligente/thegirlwiththedragontattoo.jpg";
import themaster from "../../movies/inteligente/themaster.jpg";
import thematrix from "../../movies/inteligente/thematrix.jpg";
import zodiac from "../../movies/inteligente/zodiac.jpg";

// 🎬 Datos reales
const movies = [
  {
    title: "Arrival",
    image: arrival,
    director: "Denis Villeneuve",
    year: 2016,
    cast: "Amy Adams, Jeremy Renner, Forest Whitaker",
    synopsis: "Una lingüista intenta comunicarse con extraterrestres recién llegados a la Tierra."
  },
  {
    title: "Enemy",
    image: enemy,
    director: "Denis Villeneuve",
    year: 2013,
    cast: "Jake Gyllenhaal, Mélanie Laurent",
    synopsis: "Un profesor descubre a su doble exacto y se ve envuelto en un misterio obsesivo."
  },
  {
    title: "Inception",
    image: inception,
    director: "Christopher Nolan",
    year: 2010,
    cast: "Leonardo DiCaprio, Joseph Gordon-Levitt, Ellen Page",
    synopsis: "Un ladrón especializado en robar secretos del subconsciente se enfrenta a un último trabajo imposible."
  },
  {
    title: "Memento",
    image: memento,
    director: "Christopher Nolan",
    year: 2000,
    cast: "Guy Pearce, Carrie-Anne Moss, Joe Pantoliano",
    synopsis: "Un hombre con pérdida de memoria a corto plazo busca al asesino de su esposa, usando notas y tatuajes."
  },
  {
    title: "Mr. Nobody",
    image: mrnobody,
    director: "Jaco Van Dormael",
    year: 2009,
    cast: "Jared Leto, Sarah Polley, Diane Kruger",
    synopsis: "Explora la vida de Nemo Nobody y las distintas posibilidades que sus decisiones crean."
  },
  {
    title: "Notes on a Scandal",
    image: notesonascandal,
    director: "Richard Eyre",
    year: 2006,
    cast: "Cate Blanchett, Judi Dench",
    synopsis: "Una profesora tiene un affaire con un estudiante, y su secreto es manipulado por una colega obsesiva."
  },
  {
    title: "The Girl with the Dragon Tattoo",
    image: thegirlwiththedragontattoo,
    director: "David Fincher",
    year: 2011,
    cast: "Daniel Craig, Rooney Mara",
    synopsis: "Un periodista y una hacker investigan la desaparición de una joven en una familia rica y oscura."
  },
  {
    title: "The Master",
    image: themaster,
    director: "Paul Thomas Anderson",
    year: 2012,
    cast: "Joaquin Phoenix, Philip Seymour Hoffman",
    synopsis: "La relación entre un líder carismático de culto y un hombre perturbado en la posguerra."
  },
  {
    title: "The Matrix",
    image: thematrix,
    director: "Lana y Lilly Wachowski",
    year: 1999,
    cast: "Keanu Reeves, Laurence Fishburne, Carrie-Anne Moss",
    synopsis: "Un hacker descubre que la realidad es una simulación y lidera la rebelión contra las máquinas."
  },
  {
    title: "Zodiac",
    image: zodiac,
    director: "David Fincher",
    year: 2007,
    cast: "Jake Gyllenhaal, Robert Downey Jr., Mark Ruffalo",
    synopsis: "Basada en hechos reales: la búsqueda de un asesino en serie que aterroriza San Francisco en los años 70."
  },
];

// ⭐⭐⭐⭐⭐ Letterboxd-style SVGs (IDs namespaced for this component)
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient_intel">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient_intel)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Inteligente() {
  // scroll
  useEffect(() => window.scrollTo(0, 0), []);

  // STORAGE separado para este componente
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMovies_Inteligente") || "{}")
  );
  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatings_Inteligente") || "{}")
  );

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMovies_Inteligente", JSON.stringify(s));

    // si se desmarca como vista, sacar rating
    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatings_Inteligente", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatings_Inteligente", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Inteligente</h1>
      <p>
        Razona cada cosa que encuentra en su camino, capaz de analizar y entender todo, incluso
        dándole su impronta. Tiene una inteligencia creativa magistral; por a o por b, a corto o largo
        plazo la vida le termina dando la razón, incluso cuando la intuición manda.
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = Boolean(seen[movie.title]);
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className={`movie-card ${isSeen ? "movie-card-seen" : ""}`}>
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    type="button"
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Inteligente;


